// extracted by mini-css-extract-plugin
export default {"h":"styles_h__JaR4p","p":"styles_p__AUTKG","box":"styles_box__KBsz4"};